/**
 * Bold Express Add-ons — keep variant + quantity in sync with the Monthlees product form.
 * Bold reads these from form[action*="/cart/add"] on click; empty sibling inputs break add-ons.
 */
(function () {
  'use strict';

  var pdp = document.querySelector('.monthlees-pdp[data-product-id]');
  if (!pdp) return;

  var purchaseCard = pdp.querySelector('.monthlees-pdp__purchase-card');
  if (!purchaseCard) return;

  var productForm = purchaseCard.querySelector('form.monthlees-product-form[action*="/cart/add"]');
  if (!productForm) return;

  var expressRoot = purchaseCard.querySelector('[data-app-zone="bold-express-addons"]');
  if (!expressRoot) return;

  function getVariantId() {
    var variantField = productForm.querySelector('[name="id"]');
    if (!variantField) return '';
    return String(variantField.value || '').trim();
  }

  function normalizeQuantity(value) {
    var parsed = parseInt(String(value || '').trim(), 10);
    if (!parsed || parsed < 1) return 1;
    return parsed;
  }

  function getCanonicalQuantity() {
    var qtyInput = productForm.querySelector('[data-monthlees-pdp-quantity], [name="quantity"]');
    if (!qtyInput) return 1;

    var qty = normalizeQuantity(qtyInput.value);
    if (String(qtyInput.value) !== String(qty)) {
      qtyInput.value = String(qty);
    }
    return qty;
  }

  function syncPurchaseCardFields() {
    var qty = getCanonicalQuantity();
    var variantId = getVariantId();

    purchaseCard.querySelectorAll('[name="quantity"]').forEach(function (input) {
      if (productForm.contains(input)) return;
      if (normalizeQuantity(input.value) !== qty) {
        input.value = String(qty);
      }
    });

    if (!variantId) return;

    purchaseCard.querySelectorAll('[name="id"]').forEach(function (input) {
      if (productForm.contains(input)) return;
      if (String(input.value || '').trim() !== variantId) {
        input.value = variantId;
      }
    });
  }

  function handleExpressAction(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var button = target.closest('[class*="add-to-order-button"], [class*="add-subs-button"]');
    if (!button || !expressRoot.contains(button)) return;

    syncPurchaseCardFields();
    getCanonicalQuantity();
  }

  syncPurchaseCardFields();

  var qtyInput = productForm.querySelector('[data-monthlees-pdp-quantity], [name="quantity"]');
  if (qtyInput) {
    qtyInput.addEventListener('change', syncPurchaseCardFields);
    qtyInput.addEventListener('input', syncPurchaseCardFields);
  }

  var variantField = productForm.querySelector('[name="id"]');
  if (variantField) {
    variantField.addEventListener('change', syncPurchaseCardFields);
  }

  purchaseCard.addEventListener('click', handleExpressAction, true);
  purchaseCard.addEventListener('mousedown', handleExpressAction, true);

  if (typeof MutationObserver === 'function') {
    var observer = new MutationObserver(function () {
      syncPurchaseCardFields();
    });
    observer.observe(purchaseCard, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
  }
})();
